module.exports = __webpack_public_path__ + "img/cover-redeem-bg.71314f8c.png";